import * as React from "react";
import IntlMessages from "../../helpers/IntlMessages";

class PrintAlacarteReport extends React.Component {
  render() {
    const { AlacarteInfo, restaurantName, slot } = this.props;
    const AlacarteInfoFiltered = AlacarteInfo.filter(
      item => item.service_type && item.service_type === "ALACARTE_RESTAURANT_RESERVATION"
    );

    const CountFood = () => {
      const foodList = {};
      AlacarteInfoFiltered.forEach(info => {
        JSON.parse(info.custom_fields_values.find(cfv => cfv.id == "213")?.value).forEach(order => {
          foodList[order.main_course_name] = (foodList[order.main_course_name] || 0) + 1;
        });
      });
      return Object.entries(foodList).map(([food, count], index) => (
        <tr key={index}>
          <td colSpan={4}>
            {food == "undefined" ? <IntlMessages id="alacarte.food_undefined" /> : food}
          </td>
          <td>{count}</td>
        </tr>
      ));
    };

    const countGrandTotal = () => {
      let grandTotal = 0;
      AlacarteInfoFiltered.forEach(info => {
        JSON.parse(info.custom_fields_values.find(cfv => cfv.id == "213")?.value)
          .forEach(order => { grandTotal += 1; });
      });
      return (
        <tr>
          <th colSpan={4}>
            <IntlMessages id="alacarte.grand_total" />
          </th>
          <th>{grandTotal}</th>
        </tr>
      );
    };

    return (
      <div>
        <div className="mt-5 print-table" style={{ paddingRight: "28px" }}>
          <table>
            <thead>
              <tr>
                <th colSpan={5}>
                  <IntlMessages id="alacarte.restaurant_name" />: {restaurantName}
                </th>
              </tr>
              <tr>
                <th colSpan={5}>
                  <IntlMessages id="alacarte.reservation_slot" />: {slot}
                </th>
              </tr>
              <tr>
                <th>
                  <IntlMessages id="alacarte.name" />
                </th>
                <th>
                  <IntlMessages id="alacarte.main_course" />
                </th>
                <th>
                  <IntlMessages id="alacarte.room_number" />
                </th>
                <th>
                  <IntlMessages id="request.status" />
                </th>
                <th>
                  <IntlMessages id="alacarte.request_time" />
                </th>
              </tr>
            </thead>

            <tbody>
              {AlacarteInfoFiltered?.map((res, index) => {
                let value = JSON.parse(res.custom_fields_values.find(cfv => cfv.id == "213")?.value);
                return (value?.map((response, index) => (
                  <tr key={response.name + res.updated_at_date + index}>
                    <td>{response.name}</td>
                    <td>{response.main_course_name}</td>
                    <td>{response.room}</td>
                    <td>{res.status}</td>
                    <td>{res.due_at_date}</td>
                  </tr>
                )));
              })}
            </tbody>

            <tfoot>
              <tr>
                <td colSpan={5}> </td>
              </tr>
              <tr>
                <th colSpan={5}>
                  <IntlMessages id="alacarte.total_order" />
                </th>
              </tr>

              {CountFood()}
              {countGrandTotal()}
            </tfoot>
          </table>
        </div>
      </div>
    );
  }
}
export default PrintAlacarteReport;
